import type { PlaybackRate } from 'bundles/video-player/types/VideoPlayer';

const exported = {
  // Percentage to deem that a video is completed
  videoEndPercentage: 0.9,

  // if playing the video from a specific time point,
  // we start the video earlier by this many seconds
  videoStartPlaybackDelay: 3,

  // set of possible playback rates
  playbackRates: [0.75, 1, 1.25, 1.5, 1.75, 2],
};

export default exported;

export const { videoEndPercentage, videoStartPlaybackDelay, playbackRates } = exported;

export const VIDEO_LOWEST_RES = '240p';
export const VIDEO_LOW_RES = '360p';
export const VIDEO_MID_RES = '540p';
export const VIDEO_HIGH_RES = '720p';
export const VIDEO_MAX_RES = '1080p';

export const MODERN_VIDEO_PLAYER_CONTROL_BAR_HEIGHT = 64;

export const NOT_SET = -1;

export const VIDEO_PLAYER_SUBTITLE_NOT_SET = 'none';

export const VIDEO_PLAYER_AUDIO_LANGUAGE_NOT_SET = 'none';

export const VIDEOPLAYER_FOCUS_OUTLINE_THICKNESS = 2;

export const DEFAULT_NORMAL_BANDWIDTH_VIDEO_PLAYER_RESOLUTION = VIDEO_MID_RES;

// Default resolution for countries with low bandwidth
export const DEFAULT_LOW_BANDWIDTH_VIDEO_PLAYER_RESOLUTION = VIDEO_LOW_RES;

// Countries considered to have low bandwidth
export const LOW_BANDWIDTH_COUNTRIES = ['CN', 'IN'];

export const playbackRatesTyped: PlaybackRate[] = [0.75, 1, 1.25, 1.5, 1.75, 2];
